export default function () {
    return (
        <svg width="401" height="82" viewBox="0 0 401 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M126.191 50.1596H134.187L138.381 34.5187H174.598L176.802 26.3157H132.58L126.191 50.1596Z" fill="white" />
            <path d="M134.578 18.8776H178.792L180.988 10.6746H136.774L134.578 18.8776Z" fill="white" />
            <path
                d="M214.29 42.2091H186.505L194.922 10.7053H186.704L178.172 42.5381C177.039 46.7697 179.549 50.1902 183.773 50.1902H220.342L230.925 10.7053H222.707L214.29 42.2091Z"
                fill="white"
            />
            <path
                d="M339.241 10.6746H313.346C308.28 10.6746 303.069 14.7837 301.707 19.8571L296.052 40.9846C294.69 46.0503 297.698 50.1671 302.771 50.1671H328.666C333.731 50.1671 338.942 46.0579 340.304 40.9846L345.959 19.8571C347.321 14.7837 344.314 10.6746 339.241 10.6746ZM332.469 40.403C332.212 41.2748 331.433 41.8889 330.525 41.9334H305.311C304.93 41.9528 304.564 41.7786 304.339 41.4701C304.114 41.1616 304.059 40.7604 304.194 40.403L309.551 20.431C309.811 19.5619 310.588 18.9496 311.494 18.9006H336.746C337.128 18.8812 337.493 19.0554 337.718 19.3639C337.944 19.6724 337.998 20.0736 337.863 20.431L332.469 40.403Z"
                fill="white"
            />
            <path d="M277.955 50.1594H285.952L296.534 10.6746H288.53L277.955 50.1594Z" fill="white" />
            <path
                d="M240.475 26.3155L242.465 18.8776H278.705L280.901 10.6746H244.332C240.108 10.6746 235.762 14.1027 234.629 18.3267L230.29 34.5568H266.531L264.533 41.9947H228.293L226.104 50.1901H262.666C266.898 50.1901 271.237 46.7696 272.369 42.538L276.708 26.3461L240.475 26.3155Z"
                fill="white"
            />
            <path
                d="M392.056 10.6746L384.58 38.5895L364.462 10.6746H364.271H356.053L345.478 50.1594H353.696L361.172 22.2445L381.289 50.1594H384.037H389.699L400.274 10.6746H392.056Z"
                fill="white"
            />
            <path d="M100.296 34.5569H122.388L124.584 26.3462H102.5L100.296 34.5569Z" fill="white" />
            <path d="M53.8707 0H31.603L51.0546 26.3232L65.257 15.4267L53.8707 0Z" fill="white" />
            <path d="M76.5822 60.8419H98.8576L81.0051 36.6919L65.6396 46.0351L76.5822 60.8419Z" fill="white" />
            <path d="M119.258 0H91.2744L42.8824 37.1204H53.4807L0 82L91.611 26.3539H80.8981L119.258 0Z" fill="url(#paint0_linear_540_1744)" />
            <defs>
                <linearGradient id="paint0_linear_540_1744" x1="112.662" y1="-5.23546e-07" x2="0.13962" y2="81.8658" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
